import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root, BootstrapInput } from './Department.css';
import PageTitle from '../Layout/components/PageTitle'
import { Button, NativeSelect, Paper, Table, TableHead, TableRow, TableCell, TableBody, Dialog, InputBase, TableFooter, TablePagination } from '@material-ui/core';
import DeptInfo from '../Department/components/DeptInfo'
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { defaultPageSize, globalData, ADD, EDIT, VIEW } from '../../common/common'
import { clone, timeFormat } from '../../common/utils'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'

const ALL = "All Department";
class Department extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            crtOffice: "All Department",
            searchDept: "",
            open: false,
            dialogTitle: "",
            dialogState: ADD,
            currentObj: null,
            navDeptData: [],
            navDeptDataCopy: [],
            officeData: [],
            officeNoAllData: [],
            deptData: [],
            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,
            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
        };
        this.handleOfficeChange = this.handleOfficeChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleAddDep = this.handleAddDep.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    }
    render() {
        const {
            open,
            crtOffice,
            officeData,
            officeNoAllData,
            showToast,
            toastMsg,
            toastState,
            showAlert,
            dialogTitle,
            dialogState,
            currentObj,
            deptData,
            page_index,
            page_size,
            total_items,
        } = this.state;
        return (
            <Root>
                <div className="head h">
                    <PageTitle title="All Department" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleAddDep}>ADD DEPARTMENT</Button>
                    </div>
                </div>
                <div className="h">
                    <NativeSelect
                        onChange={this.handleOfficeChange}
                        input={<BootstrapInput />}
                        value={crtOffice}
                    >
                        {officeData.map((item, index) => (
                            <option value={item} key={index}>{item}</option>
                        ))}
                    </NativeSelect>
                    <div className="search h">
                        <div className="search-icon c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search Dept. Name"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={this.handleSearch}
                        />
                    </div>
                </div>
                {/* 表格 */}
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell className="cell">Office</TableCell>
                                {/* <TableCell>Dept. ID</TableCell> */}
                                <TableCell className="cell">Dept. Name</TableCell>
                                <TableCell className="cell">Team Amount</TableCell>
                                <TableCell className="cell">Update Time</TableCell>
                                <TableCell className="cell">Create Time</TableCell>
                                <TableCell className="cell">Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="tableBody">
                            {deptData.map(row => (
                                <TableRow key={row.id} hover={true} role="checkbox">
                                    <TableCell>{row.office}</TableCell>
                                    {/* <TableCell component="th" scope="row">
                                        {row.id}
                                    </TableCell> */}
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.teams.length}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleItem(e, row)}>Team</Button>
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {deptData.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={deptData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={open}>
                    <DeptInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={currentObj}
                        officeData={officeNoAllData}
                        state={dialogState}
                    ></DeptInfo>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this department?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        // this.getDepts();
        this.getDeptOffice(() => {
            this.getDepts();
        });
    }
    getDepts() {
        const { page_index, page_size, crtOffice, searchDept } = this.state;
        let params = {
            office: crtOffice === "All Department" ? "" : crtOffice,
            name: searchDept,
            page_index,
            page_size
        }
        this.getDepartments(params, () => {
            // const { officeData } = this.state;
            // if (officeData[0]) {
            //     let recordOffice = localStorage.getItem("crtOffice");
            //     let crtOffice = recordOffice ? recordOffice : officeData[0].office;
            //     this.selectOffice(crtOffice);
            // }
        });
    }
    //选择office
    handleOfficeChange(e) {
        const value = e.target.value
        console.log("valuevaluevaluevalue", value)
        // this.selectOffice(value);
        this.setState({
            crtOffice: value
        }, () => {
            this.getDepts();
        });
    }

    //关闭dialog
    handleCloseDialog() {
        this.closeDialog();
    }
    //选择department
    handleItem(e, obj) {
        globalData.currentDepId = obj.id;
        this.props.history.push({ pathname: '/main/team' });
        localStorage.setItem('dept_id', obj.id);
        localStorage.setItem('dept_name', obj.name);
    }
    //添加department
    handleAddDep() {
        this.openDialog("ADD DEPARTMENT", ADD);
    }
    //查看、更新department
    handleView(e, obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog("VIEW DEPARTMENT INFO", VIEW);
    }
    //编辑department下的team
    handleEdit(e, obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDialog("EDIT DEPARTMENT INFO", EDIT);
    }
    //删除department
    //如果office没有了就自动选择第一个
    handleDel(e, obj) {
        this.setState(() => ({
            currentObj: obj,
            showAlert: true
        }));
    }
    delDept() {
        const { currentObj } = this.state;
        const office = currentObj.office;
        this.delDepartments(currentObj.id, () => {
            this.getDeptOffice(() => {
                this.getDepartments(() => {
                    const { officeData } = this.state;
                    let crtOffice = "";
                    let haveOffice = false;
                    for (const obj of officeData) {
                        if (obj.office === office) {
                            haveOffice = true;
                        }
                    }
                    if (haveOffice) {
                        crtOffice = office;
                        this.showToast("Successfully deleted", "success");
                    } else {
                        crtOffice = officeData[0].office;
                        this.showToast("Successfully deleted" + office + "The number of departments is 0, and a list of all offices and departments will be displayed", "success");
                    };
                    this.selectOffice(crtOffice);
                });
            });
        });
    }
    //添加、修改department点击确定后
    handleCreate(name, description, office, membersObj) {
        const { dialogState, currentObj } = this.state;
        if (name === "") {
            this.showToast("Please fill in Dept. name", "error");
            return;
        } else if (office === "") {
            this.showToast("Please fill in Office", "error");
            return;
        }

        let params = {
            name,
            office,
            description,
        }
        if (dialogState === ADD) {//增加
            params.members = membersObj.addMembers;

            if (params.members === null || params.members.length === 0) {
                this.showToast("Please choose one manager at least", "error");
                return;
            }

            this.createDepartments(params, () => {
                this.getDeptOffice(() => {
                    this.getDepartments(() => {
                        this.selectOffice(office)
                    });
                });
            });
        } else if (dialogState === EDIT) {//更新
            const id = currentObj.id;
            this.updateDepartments(id, params, () => {
                this.updateMembers(id, membersObj, () => {
                    this.getDeptOffice(() => {
                        this.getDepartments(() => {
                            this.selectOffice(office)
                        });
                    });
                });
            });
        }
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getDepts();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getDepts();
        });
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleSearch(e) {
        const value = e.target.value;
        this.setState({
            searchDept: value
        }, () => {
            this.getDepts();
        })
        // const { navDeptDataCopy } = this.state;
        // const arr = this.filterIncludeArr(navDeptDataCopy, value);
        // this.setState(() => ({
        //     navDeptData: arr
        // }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleAlertYes() {
        this.delDept();
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            currentObj: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    selectOffice(crtOffice) {
        console.log(crtOffice)
        const { deptData } = this.state;
        localStorage.setItem("crtOffice", crtOffice);
        let navDeptData = [];
        if (crtOffice === ALL) {
            navDeptData = deptData;
        } else {
            navDeptData = this.filterDepartment(crtOffice);
        }
        this.setState(() => ({
            crtOffice,
            navDeptData,
            navDeptDataCopy: navDeptData
        }));
    }
    filterDepartment(name) {
        const { deptData } = this.state;
        let newObjArr = [];
        for (const obj of deptData) {
            if (obj.office === name) {
                newObjArr.push(obj);
            }
        }
        return newObjArr
    }
    filterIncludeArr(arr, value) {
        let newArr = [];
        for (let obj of arr) {
            if (obj.name.includes(value)) {
                newArr.push(obj);
            };
        }
        return newArr;
    }
    updateMembers(deptId, membersObj, callback) {
        const addMembers = membersObj.addMembers;
        const delMembers = membersObj.delMembers;
        const addIndex = addMembers.length;
        const delIndex = delMembers.length;

        if (addIndex <= 0 && delIndex <= 0) {
            callback();
        } else if (addIndex > 0 && delIndex > 0) {
            this.addMembers(deptId, addMembers, () => {
                this.delMembers(deptId, delMembers, () => {
                    callback();
                });
            });
        } else if (addIndex > 0) {
            this.addMembers(deptId, addMembers, () => {
                callback();
            });
        } else if (delIndex > 0) {
            this.delMembers(deptId, delMembers, () => {
                callback();
            });
        }
    }
    //------------request-----------
    getDeptOffice(callback = null) {
        instance.get(BASE_URL + 'admin/departments/office').then((res) => {
            const officeData = res.data.data;
            const all = "All Department"
            const officeNoAllData = clone(officeData);
            officeData.splice(0, 0, all);
            this.setState({
                officeData,
                officeNoAllData,
            }, () => {
                if (callback) callback();
            });
        })
    }
    getDepartments(params, callback = null) {
        instance.get(BASE_URL + 'common/departments', { params }).then((res) => {
            const deptData = res.data.data;
            console.log("deptDatadeptDatadeptData", deptData)
            this.setState({
                deptData
            }, () => {
                if (callback) callback();
            });
        })
    }
    createDepartments(params, callback) {
        instance.post(BASE_URL + 'admin/departments', params).then((res) => {
            this.showToast("Added successfully", "success");
            callback();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateDepartments(dept_id, params, callback) {
        instance.put(BASE_URL + 'admin/departments/' + dept_id, params).then((res) => {
            this.showToast("Successfully modified", "success");
            callback();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delDepartments(dept_id, callback) {
        instance.delete(BASE_URL + 'admin/departments/' + dept_id).then((res) => {
            this.showToast("Successfully deleted", "success");
            callback();
        }).catch((err) => {
            // const msg = err.response.data.message;
            const errorCode = err.response.data.error;
            console.log("errorCode")
            console.log(errorCode)
            if (errorCode === 2000) {
                this.showToast("There is a team in this department", "error");
            }
        })
    }
    addMembers(department_id, members, callback) {
        let params = {
            members
        }
        instance.post(BASE_URL + 'admin/departments/' + department_id + '/managers', params).then((res) => {
            callback();
        })
    }
    delMembers(department_id, members, callback) {
        let params = {
            members
        }
        instance.delete(BASE_URL + 'admin/departments/' + department_id + '/managers', { data: params }).then((res) => {
            callback();
        })
    }
}

export default withRouter(Department);